<template>
  <page-view>
    <template slot="action">
      <a-space size="small">
        <a-button type="primary" @click="onSave" :loading="saveLoading">提交</a-button>
      </a-space>
    </template>
    <div id="Base-Props" style="position: absolute;top: 0"></div>
    <a-anchor class="t-anchor">
      <a-anchor-link href="#Base-Props" title="基础"/>
      <a-anchor-link href="#Table-Props" title="专家"/>
      <a-anchor-link href="#Link-Props" title="项目"/>
    </a-anchor>
    <a-card>
      <a-spin :spinning="spinLoading">
        <a-form-model :model="form" ref="form" :rules="rules" class="custom pick-100 form-input">
          <a-row v-if="!ifEdit">
            <process-selector @change="onChangeProcess"/>
          </a-row>
          <div class="hp-title">
            <div>&nbsp;</div>
            <span>基础信息</span>
          </div>
          <a-row>
            <a-col :span="7">
              <a-form-model-item label="申请处室" prop="applyDept">
                <dept-selector v-if="deptDisabled" :value="form.applyDept" @change="v => form.applyDept = v" style="width: 100%"/>
                <a-input v-else disabled v-model="deptName"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="申请人" prop="applyUser">
                <user-selector :value="form.applyUser" @change="v => form.applyUser = v" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="专家出行日期" prop="applyDate">
                <a-date-picker style="width: 100%" :format="'yyyy-MM-DD'" v-model="form.applyDate"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="7">
              <a-form-model-item label="计划使用天数" prop="planDays">
                <a-input-number placeholder="请输入" @change="totalPrices" :min="0.5" :max="365"
                                :formatter="(value)=>{
                                             let reg = /^(-)*(\d+)\.(\d).*$/;
                                              return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg,'$1$2.$3');
                                            }"
                                :parser="(value)=>{
                                              let reg = /^(-)*(\d+)\.(\d).*$/;
                                              return value.replace(/\s?|(,*)/g, '').replace(reg,'$1$2.$3');
                                            }"
                                :step="0.5" v-model="form.planDays" style="width:100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" offset="1">
              <a-form-model-item label="专家人数" prop="expertNumber">
                <a-input-number placeholder="请输入" :precision="0" @change="totalPrices" :min="1" :max="20" v-model="form.expertNumber" style="width:100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="7" :offset="1">
              <a-form-model-item label="计划专家费用" prop="planExpertFees">
                <dict-cascader @change="totalPrices" dictKey="expertExpenditure_reward" v-model="form.planExpertFees" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="7">
              <a-form-model-item label="总价" prop="planTotalPrices">
                <a-input readOnly disabled v-model="form.planTotalPrices"/>
              </a-form-model-item>
            </a-col>
          </a-row>

          <!-- 专家录入 -- 外部的 -->
          <div class="hp-title">
            <div>&nbsp;</div>
            <span>库外专家信息</span>
          </div>
          <div id="Table-Props" style="position: absolute;top: 0"></div>
          <a-row>
            <a-col :span="23">
              <table class="fx-form-add">
                <tr>
                  <th class="not-null">名称</th>
                  <th class="not-null">性别</th>
                  <th class="not-null">所属组别</th>
                  <th class="not-null">联系电话</th>
                  <th class="not-null">身份证号</th>
                  <th class="not-null">职称</th>
                  <th>从事专业</th>
                  <th>擅长专业</th>
                  <th style="width: 20px">
                    <a-button style="display: block;margin: 0 auto" :size="'small'" type="primary" icon="plus" title="增加专家" @click="addCol"></a-button>
                  </th>
                </tr>
                <tr v-for="(item,index) in form.expertInfos" :key="index">
                  <td class="style-table-td">
                    <a-form-model-item prop="name">
                      <a-input placeholder="请输入" v-model="item.name"/>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item prop="gender">
                      <dict-cascader style="width: 100%" dictKey="PEOPLE.SEX" placeholder="请选择" v-model="item.gender"/>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item prop="groups">
                      <a-select placeholder="请选择" v-model="item.groups">
                        <a-select-option v-for="(item,i) in groups" :key="i" :value="item.value">{{ item.name }}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item prop="mobilePhone">
                      <a-input placeholder="请输入" v-model="item.mobilePhone"/>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item prop="idCard">
                      <a-input placeholder="请输入" v-model="item.idCard"/>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item prop="professionalTitle">
                      <dict-cascader style="width: 100%" dictKey="expert_professionalTitle" placeholder="请选择" v-model="item.professionalTitle"/>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item prop="workProfession">
                      <a-input placeholder="请输入" v-model="item.workProfession"/>
                    </a-form-model-item>
                  </td>
                  <td>
                    <a-form-model-item prop="skilledProfession">
                      <a-input placeholder="请输入" v-model="item.skilledProfession"/>
                    </a-form-model-item>
                  </td>
                  <td class="style-table-td">
                    <a-form-item>
                      <a-button style="display: block;margin: 0 auto" type="primary" icon="minus" title="最后一行无法删除" v-if="(index === 0 && form.expertInfos.length === 1)" disabled/>
                      <a-button style="display: block;margin: 0 auto" v-else type="danger" icon="minus" title="删除当前行" @click="() => removeCol(index)"/>
                    </a-form-item>
                  </td>
                </tr>
              </table>
            </a-col>
          </a-row>

          <div style="height: 50px" id="Link-Props" ></div>
          <div class="hp-title">
            <div>&nbsp;</div>
            <span>项目信息</span>
          </div>
          <a-row>
            <a-col :span="23">
              <a-form-model-item label="项目名称" prop="projectName">
                <a-textarea v-model="form.projectName" placeholder="请输入" rows="2"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="23">
              <a-form-model-item label="项目内容" prop="projectContent">
                <a-textarea v-model="form.projectContent" placeholder="请输入" rows="4"/>
              </a-form-model-item>
            </a-col>
          </a-row>

        </a-form-model>
      </a-spin>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import ACard from 'ant-design-vue/lib/card/Card'
import { verify } from '@epp/expertmain/common/js/verify'
import UserSelector from '@comp/selector/UserSelector'
import DeptSelector from '@comp/selector/DeptSelector'
import moment from 'moment'
import DictCascader from '@comp/dict/DictCascader'
import ProcessSelector from '@/components/workflow/ProcessSelector'

const uuidv4 = require('uuid/v4')
const rules = {
  applyUser: [{ required: true, message: '申请人不能为空！', trigger: 'change' }],
  applyDept: [{ required: true, message: '申请处室不能为空！', trigger: 'change' }],
  applyDate: [{ required: true, message: '专家出行日期不能为空！', trigger: 'change' }],
  planDays: [{ required: true, message: '计划使用天数不能为空！', trigger: 'change' }],
  planExpertFees: [{ required: true, message: '计划专家费用不能为空！', trigger: 'change' }],
  expertNumber: [{ required: true, message: '专家人数不能为空！', trigger: 'change' }],
  planTotalPrices: [{ required: true, message: '总价不能为空！', trigger: 'blur' }],
  selectExpert: [{ required: true, message: '请在填写完“专业名称”和“专家人数”之后点击“随机生成”抽取专家并点击“确定”选定专家！', trigger: 'change' }],
  projectName: [{ min: 1, max: 150, required: true, whitespace: true, message: '项目名称不能为空！最多150个字符', trigger: 'blur' }],
  projectContent: [{ min: 1, max: 300, required: true, whitespace: true, message: '项目内容不能为空！最多300个字符', trigger: 'blur' }]
}
export default {
  name: 'ExternalExpertAdd',
  components: {
    PageView,
    ACard,
    UserSelector,
    DeptSelector,
    DictCascader,
    ProcessSelector
  },
  props: {
    id: String
  },
  data () {
    return {
      spinLoading: false,
      ifEdit: false,
      saveLoading: false,
      rules,
      verify,
      deptDisabled: false,
      deptName: '',
      applyState: '2',
      form: {
        id: uuidv4(),
        expertInfos: [{
          name: '',
          gender: '',
          groups: '',
          mobilePhone: '',
          idCard: '',
          professionalTitle: '',
          workProfession: '',
          skilledProfession: ''
        }]
      },
      user: this.$ls.get('user'),
      selZYData: null,
      cfmZJList: [],
      groups: [
        { value: 'ksyj', name: '非煤矿山和冶金' },
        { value: 'jxdq', name: '机械电气' },
        { value: 'hgwh', name: '化工与危险化学品（含烟花爆竹）' },
        { value: 'jtys', name: '交通运输' },
        { value: 'gdjt', name: '轨道交通' },
        { value: 'jcgc', name: '建筑工程' },
        { value: 'xfaq', name: '消防安全' },
        { value: 'gysb', name: '工业设备（含特种设备）' },
        { value: 'xhfz', name: '汛旱风灾害' },
        { value: 'slhz', name: '森林火灾' },
        { value: 'dzdz', name: '地震地质灾害' },
        { value: 'yjzh', name: '应急指挥（含海洋灾害、生物灾害、环境污染、公共卫生、社会安全）' },
        { value: 'kjxx', name: '科技信息化' },
        { value: 'zhgl', name: '综合管理' },
        { value: 'jzjz', name: '综合减灾及灾害救援救助' }
      ]

    }
  },
  created () {
    this.deptName = this.user.dept.name
    this.deptDisabled = this.user.permissions['expert.use.admin']
    if (this.id) {
      this.loadData()
      this.ifEdit = true
    } else {
      this.form = { ...this.initForm() }
    }
  },
  watch: {

  },
  computed: {

  },
  methods: {
    onChangeProcess (id) {
      // 选择流程
      this.procId = id
    },
    initForm () {
      return {
        id: uuidv4(),
        applyUser: this.user.id,
        applyDept: this.user.deptId,
        applyDate: moment(),
        professionalName: null,
        expertInfos: [{
          name: '',
          gender: '',
          groups: '',
          mobilePhone: '',
          idCard: '',
          professionalTitle: '',
          workProfession: '',
          skilledProfession: ''
        }]
      }
    },
    async loadData () {
      this.spinLoading = true
      const res = await this.$http.get(`/api/1/expertmain/selectExpertApply/get_selectExpertApply.json?id=${this.id}`)
      this.spinLoading = false
      if (res.code !== 200) {
        return
      }
      this.form = res.result
      this.form.applyDate = moment(this.form.applyDate)
      this.selZYData = res.result.professionalName.split(',')
      this.cfmZJList = res.result.extras.expertList
    },
    totalPrices () {
      if (!this.form.planDays) {
        return
      }
      var s = this.form.planDays.toString()
      var arr = s.split('.')
      if (arr.length > 1) {
        var s1 = arr[1] + '0'
        var s2 = s1.substring(0, 1)
        if (s2 > 5) {
          this.form.planDays = Number(arr[0]) + 1
        } else if (s2 < 5) {
          this.form.planDays = Number(arr[0]) + 0.5
        }
      }
      var totalPrices = 0
      if (this.form.planDays && this.form.expertNumber && this.form.planExpertFees) {
        totalPrices = this.form.planDays * this.form.expertNumber * this.form.planExpertFees
      }
      this.form.planTotalPrices = totalPrices
    },
    removeCol (key) {
      this.form.expertInfos.splice(key, 1)
    },
    addCol () {
      const data = { ...this.form }
      if (data.expertNumber) {
        if (data.expertInfos.length >= data.expertNumber) {
          this.$error({ content: '增加的专家录入个数不能大于所设置的数量' })
          return
        }
      }
      this.form.expertInfos.push({
        name: '',
        gender: '',
        groups: '',
        mobilePhone: '',
        idCard: '',
        professionalTitle: '',
        workProfession: '',
        skilledProfession: ''
      })
    },
    onSave () {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        if (this.procId.length === 0 && !this.ifEdit) {
          this.$message.error('未选择启动流程，请选择启动流程！')
          return
        }
        const data = { ...this.form }
        data.procId = this.procId
        data.caseTypeId = this.$route.query.caseTypeId
        data.applyDate = data.applyDate.format('YYYY-MM-DD')
        data.applyState = this.applyState

        let selExpertNum = this.form.expertInfos.length
        if (data.expertNumber < selExpertNum) {
          this.$error({ content: '选取专家的数量，大于所录入的专家数量！' })
          return
        }

        // 判断专家信息
        var expertInfos = data.expertInfos
        var inRow = 1
        for (const key in expertInfos) {
          var expert = expertInfos[key]

          var nameC = expert.name.trim().length
          var nameCs = expert.name.replace(/[^\u4E00-\u9FA5]/g, '').length
          if ((nameC > nameCs && nameC !== 0) || nameC === 0 || ((nameC < 2) || (nameC > 10))) {
            this.$error({ content: '库外专家：第' + inRow + '行 的【专家名称】不可为空或不能输入除中文外的字符，且长度应在2~10个中文' })
            return
          }
          // 性别
          if (expert.gender.length === 0) {
            this.$error({ content: '库外专家：第' + inRow + '行 的【性别】请选择' })
            return
          }
          // 所属组别
          if (expert.groups.length === 0) {
            this.$error({ content: '库外专家：第' + inRow + '行 的【所属组别】请选择' })
            return
          }
          // 联系电话 mobilePhone
          var mobilePhone = /^(13[0-9]|14[5-9]|15[0|1|2|3|5|6|7|8|9]|166|17[3|5|6|7|8]|18[0-9]|19[1|8|9])\d{8}$/
          if (!mobilePhone.test(expert.mobilePhone)) {
            this.$error({ content: '库外专家：第' + inRow + '行 的【联系电话】输入有误！' })
            return
          }
          // 身份证号
          var idcard15 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/
          var idcard18 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
          if (!idcard15.test(expert.idCard)) {
            if (!idcard18.test(expert.idCard)) {
              this.$error({ content: '库外专家：第' + inRow + '行 的【身份证有误】输入有误！' })
              return
            }
          }
          // 所属组别
          if (expert.professionalTitle.length === 0) {
            this.$error({ content: '库外专家：第' + inRow + '行 的【职称】请选择' })
            return
          }
          inRow++
        }

        // return

        delete data.extras
        const api = this.id ? '/api/1/expertmain/selectExpertApply/update_selectExpertApply.json' : '/api/1/expertmain/selectExpertApply/add_selectExpertApply_external.json'
        let msgType = this.id ? '编辑' : '添加'
        this.saveLoading = true
        const res = await this.$http.post(api, data)
        this.saveLoading = false
        if (res.code !== 200) {
          this.$message.error(`${msgType}失败`)
        }
        this.$message.success(`${msgType}成功`)
        this.$router.push({
          path: '/selectExpertApply/view?id=' + data.id
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.hp-title {
  padding-top: 15px;
  padding-bottom: 15px;
}

.hp-title div {
  height: 18px;
  border-left: 5px solid dodgerblue;
  width: 15px;
  display: inline-block;
}

.hp-title span {
  font-size: 16px;
  font-weight: bold
}
.style-table{
  padding: 8px 8px;
  border: 1px solid #d9d9d9;
  color: #000;
  //background-color: #f5f5f5;
  font-weight: bold;
}
.style-table-td{
  //padding: 8px 8px;
  border: 1px solid #d9d9d9;
  color: #000;
  min-width: 20px;
  //background-color: white;
}
.not-null::before {
  /*top: 6px;*/
  /*left: 8px;*/
  color: red;
  content: '*';
  position: absolute;
  margin-left: -7px;
  font-weight: 700;
  line-height: 1.8em;
}
</style>
